<template>
  <div v-if="getContent.content">
    <header>
      <div class="logo-bar">
        <div class="container-fluid">
          <div class="row align-items-center">
            <div class="col betway-logo" style="margin-left: 7px">
              <img v-if="this.isZeroRated === false" v-bind:src="'' + this.getContent?.content?.logoImageUrl"
                style="width: 150px" />
            </div>
            <div class="col" v-if="this.isZeroRated === false && !this.isAuthenticated">
              <div class="float-end">
                <button data-bs-toggle="modal" data-bs-target="#loginModal" class="login-btn text-center">
                  {{ this.getContent?.content?.loginText }}
                </button>
                <button data-bs-toggle="modal" data-bs-target="#registerModal" class="signup-btn text-center">
                  {{ this.getContent?.content?.signUpText }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>

    <div v-if="!this.isAuthenticated">
      <webapp-BannerComponent v-if="this.isZeroRated === false" />
      <webapp-NavigationComponent v-if="this.isZeroRated === false" :active-color="this.getSiteMap?.siteMap?.MID"/>
      <RouterView v-if="this.isZeroRated === false" />
      <webapp-MainBodyComponent v-if="this.isZeroRated === false" />
      <webapp-BodyBottomComponent v-if="this.isZeroRated === false" />
      <div class="row align-items-center" style="width: 100%">
        <div class="col-12 col-lg-4 col-md-7" style="margin: auto">
          <webapp-RegistrationComponent v-if="this.isZeroRated === true" />
        </div>
      </div>
    </div>

  </div>
  <div v-if="this.isAuthenticated">
    <webapp-WelcomeComponent/>
  </div>
  <webapp-FooterComponent v-if="this.isZeroRated === false" />
</template>

<script >
import RegistrationComponent from "./components/RegistrationComponent.vue";
import NavigationComponent from "./components/NavigationComponent.vue";
import BannerComponent from "./components/BannerComponent.vue";
import MainBodyComponent from "./components/MainBodyComponent.vue";
import BodyBottomComponent from "./components/BodyBottomComponent.vue";
import FooterComponent from "./components/FooterComponent.vue";
import WelcomeComponent from "./components/WelcomeComponent.vue";

import { StorageUtil } from "./utils/storageUtils";
import { store } from "./store/store.js";

export default {
  name: "App",
  data() {
    return {
      zeroRated: false,
      deviceType: null,
    };
  },
  components: {
    "webapp-NavigationComponent": NavigationComponent,
    "webapp-BannerComponent": BannerComponent,
    "webapp-MainBodyComponent": MainBodyComponent,
    "webapp-BodyBottomComponent": BodyBottomComponent,
    "webapp-FooterComponent": FooterComponent,
    "webapp-RegistrationComponent": RegistrationComponent,
    "webapp-WelcomeComponent":  WelcomeComponent
  },
  computed: {
    isZeroRated() {
      return this.zeroRated;
    },
    isAuthenticated() {
      const storage = new StorageUtil();
      if(storage.getCookie("betway-auth")){
        return true;
      }
      return false;
    },
    getPageContent() {
      return {
        pageContent: store.pageContent
      }
    },
    getSiteMap() {
      return {
        siteMap: store.siteMap
      }
    },
    getContent() {
      return {
        content: {
          // Header content
          signUpText: store?.content?.signUpText,
          loginText: store?.content?.loginText,
          logoImageUrl: store?.content?.logoImage,
        },
      };
    }, 
  },
  mounted() {
    if (
      window.location.host.indexOf("datafree") > -1 ||
      window.location.href.indexOf("isZeroRated") > -1
    ) {
      this.zeroRated = true;
      const storage = new StorageUtil();
      storage.setSessionStorage('datafree', true);
    }
  },
};
</script>

<style>
.header-section {
  position: absolute;
  top: 0;
  width: 100%;
  display: block;
  background-color: black;
}

.navigation-link-holder:nth-child(n + 2) {
  padding-left: 50px;
}

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

html,
body {
  height: 100%;
  font-family: "Montserrat", sans-serif;
  scroll-behavior: smooth;
  line-height: 150%;
}

#nav {
  padding: 15px;
  display: flex;
  list-style-type: none;
}

#nav a {
  font-weight: bold;
  color: white;
  text-decoration: unset;
}

#nav a .router-link-exact-active {
  color: #42b983;
}

.logo {
  max-width: 150px;
  float: left;
}

.text-center {
  text-align: center !important;
}

.logo-bar {
  font-family: interface, Arial, sans-serif;
  background-color: #000;
  padding: 10px 0;
  margin-bottom: 0;
}

.login-btn {
  font-weight: 700;
  color: #439539;
  background-color: #fff;
  text-decoration: none;
  font-size: 15px;
  line-height: 1.42857143;
  text-align: center;
  border-radius: 2px;
  border: none;
  padding: 6px 12px;
  margin-right: 5px;
}

.signup-btn {
  font-weight: 700;
  color: #fff;
  background-color: #439539;
  text-decoration: none;
  font-size: 15px;
  line-height: 1.42857143;
  text-align: center;
  border-radius: 2px;
  border: none;
  padding: 6px 12px;
}

.indicators {
  display: block;
  top: 0;
  bottom: auto;
  margin-left: 0;
  margin-right: 0;
  overflow: auto;
  white-space: nowrap;
  background-color: rgba(0, 0, 0, 0.75);
}

.logo-bar {
  font-family: interface, Arial, sans-serif;
  background-color: #000;
  padding: 10px 0;
  margin-bottom: 0;
  height: 65px;
}

.logo {
  max-width: 150px;
}
</style>
